export default "__VITE_ASSET__BSXER8iE__"